jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j.extend(true, jPar.loginAndRegistration, {
	registrationPage: {
		conf: {
			emailNoticeInput: '#regFormEmail',
			emailNoticeBox: '#emailNoticeBox',
		},

		emailPermissionRetries: 0,

		init: function init() {
			this.validate.init();
			this.genderSelectBox.init();
			jPar.wdk.forms.init();
			this.socialSignOn.init();
			this.trackingInit();

			try {
				this.emailNoticeBox();
				jPar.wdk.passwordRestrictionBox.init();
				this.openDuplicateEmailModal();
			} catch (e) {
				jPar.util.log.error(e.stack, 'jPar.loginAndRegistration.registrationPage.init: low prio failed');
			}
		},

		openDuplicateEmailModal: function init() {
			if ($j('#duplicateEmail').length > 0) {
				jPar.wdk.modalbox.show({ modalboxId: 'duplicateEmail' });
			}
		},

		genderSelectBox: {
			init: function () {
				const _this = this;
				document.querySelectorAll('#formRegistration #mysexRow input[type=radio]').forEach(function (mySexRadio) {
					mySexRadio.addEventListener('click', function (event) {
						_this.mySexClick(event);
					});
				});

				document.querySelectorAll('#formRegistration #essexRow input[type=checkbox]').forEach(function (esSexCheckbox) {
					esSexCheckbox.addEventListener('click', function (event) {
						_this.esSexClick(event);
					});
				});
			},

			mySexClick: function (event) {
				document.querySelectorAll('#formRegistration input[type=radio]').forEach(function (currentElem) {
					currentElem.closest('label').classList.remove('selected');
				});
				event.target.closest('label').classList.add('selected');

				this.preselectEsSex(event.target);
				this.handleHideError();
			},

			esSexClick: function (event) {
				event.preventDefault();
				event.stopPropagation();

				window.setTimeout(function () {
					// Der Browser meldet hier ansonsten falschen checked status
					if (event.target.checked === false) {
						event.target.checked = true;
						event.target.closest('label').classList.add('selected');
					} else {
						const othercheckboxId = event.target.id === 'essexM' ? 'essexW' : 'essexM';
						const deselectAllowed = document.querySelector('#essexRow #' + othercheckboxId).checked === true;
						if (deselectAllowed) {
							event.target.checked = false;
							event.target.closest('label').classList.remove('selected');
						}
					}
				}, 0);

				this.preselectMySex(event.target);
				this.syncEsSexForSubmit();
				this.handleHideError();
			},

			preselectMySex: function (changedElement) {
				if (jPar.wdk.brands.forBrands(['ps', 'ep'])) {
					const hasNotCheckedMySex = document.querySelectorAll('#formRegistration #mysexRow [type=radio]:checked').length === 0;
					if (hasNotCheckedMySex) {
						const esSexValue = changedElement.value;
						const isGayAndEssexFemale = esSexValue === '1' && document.querySelector('#formRegistration.gay') !== null;
						const isHeteroAndEssexMale = esSexValue === '0' && document.querySelector('#formRegistration.hetero') !== null;

						if (isGayAndEssexFemale || isHeteroAndEssexMale) {
							document.querySelector('#formRegistration #mysexW').click();
						} else {
							document.querySelector('#formRegistration #mysexM').click();
						}
					}
				}
			},

			preselectEsSex: function (changedElement) {
				if (jPar.wdk.brands.forBrands(['ps', 'ep'])) {
					const hasNotCheckedEsSex = document.querySelectorAll('#formRegistration #essexRow [type=checkbox]:checked').length === 0;
					if (hasNotCheckedEsSex) {
						// 0 = male; 1 = female; 3 = all;
						const mySexValue = changedElement.value;
						const isGayAndMysexFemale = mySexValue === '1' && document.querySelector('#formRegistration.gay') !== null;
						const isHeteroAndMysexMale = mySexValue === '0' && document.querySelector('#formRegistration.hetero') !== null;

						if (isGayAndMysexFemale || isHeteroAndMysexMale) {
							document.querySelector('#formRegistration #essexW').click();
						} else {
							document.querySelector('#formRegistration #essexM').click();
						}
					}
				}
			},

			syncEsSexForSubmit: function () {
				const femaleChecked = document.querySelector('#formRegistration #essexRow #essexW:checked') !== null;
				const maleChecked = document.querySelector('#formRegistration #essexRow #essexM:checked') !== null;

				if (femaleChecked && maleChecked) {
					document.querySelector('#hiddenEssex').value = '3';
				} else if (femaleChecked) {
					document.querySelector('#hiddenEssex').value = '1';
				} else if (maleChecked) {
					document.querySelector('#hiddenEssex').value = '0';
				}
			},

			handleHideError: function () {
				const mysexChecked = document.querySelectorAll('#formRegistration #mysexRow [type=radio]:checked').length === 1;
				const essexChecked = document.querySelectorAll('#formRegistration #essexRow [type=checkbox]:checked').length >= 1;
				if (mysexChecked && essexChecked) {
					jPar.wdk.forms.hideError($j('#regsexError'));
				}
			},
		},

		// Toggeld die Hilfebox zur Email-Adresse (unsichtbar und gut geschuetzt usw.)
		emailNoticeBox: function emailNoticeBox() {
			const _this = this;

			$j(_this.conf.emailNoticeInput).on('focus', function () {
				$j(_this.conf.emailNoticeBox).fadeIn(400);
			});
			$j(_this.conf.emailNoticeInput).on('blur', function () {
				$j(_this.conf.emailNoticeBox).fadeOut(400);
			});
		},

		trackingInit() {
			jPar.util.log.bigData({
				category: 'registration',
				subcategory: 'registration_start_screen',
				action: 'view',
			});

			document.querySelector('#formRegistration').addEventListener('submit', function () {
				jPar.util.log.bigData({
					category: 'registration',
					subcategory: 'registration_start_screen',
					action: 'click',
					targetId: 'button_registration',
				});
			});
		},
	},
});
